/**
 * Generated by orval v6.29.1 🍺
 * Do not edit manually.
 * Magento API
 * <a href='/'>API Documentation</a>
 * OpenAPI spec version: 2.0.0
 */
import {useMutation, useQuery, useSuspenseQuery} from '@tanstack/react-query';
import type {
    MutationFunction,
    QueryFunction,
    QueryKey,
    UseMutationOptions,
    UseMutationResult,
    UseQueryOptions,
    UseQueryResult,
    UseSuspenseQueryOptions,
    UseSuspenseQueryResult,
} from '@tanstack/react-query';
import type {
    A605433a59281bc20230da23c0f4c2f6200Item,
    CustomerAddress,
    CustomerApiCurrent200,
    ErrorResponse,
} from '../magentoAPI.schemas';
import {fetcherMagento} from '../../axios-instance';

/**
 * @summary Get some important data
 */
export const customerApiCurrent = (signal?: AbortSignal) => {
    return fetcherMagento<CustomerApiCurrent200>({
        url: `/customer/api/current`,
        method: 'GET',
        signal,
    });
};

export const getCustomerApiCurrentQueryKey = () => {
    return [`/customer/api/current`] as const;
};

export const getCustomerApiCurrentQueryOptions = <
    TData = Awaited<ReturnType<typeof customerApiCurrent>>,
    TError = unknown,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof customerApiCurrent>>, TError, TData>>;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getCustomerApiCurrentQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerApiCurrent>>> = ({signal}) =>
        customerApiCurrent(signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof customerApiCurrent>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type CustomerApiCurrentQueryResult = NonNullable<
    Awaited<ReturnType<typeof customerApiCurrent>>
>;
export type CustomerApiCurrentQueryError = unknown;

/**
 * @summary Get some important data
 */
export const useCustomerApiCurrent = <
    TData = Awaited<ReturnType<typeof customerApiCurrent>>,
    TError = unknown,
>(options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof customerApiCurrent>>, TError, TData>>;
}): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getCustomerApiCurrentQueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getCustomerApiCurrentSuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof customerApiCurrent>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerApiCurrent>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getCustomerApiCurrentQueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof customerApiCurrent>>> = ({signal}) =>
        customerApiCurrent(signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof customerApiCurrent>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type CustomerApiCurrentSuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof customerApiCurrent>>
>;
export type CustomerApiCurrentSuspenseQueryError = unknown;

/**
 * @summary Get some important data
 */
export const useCustomerApiCurrentSuspense = <
    TData = Awaited<ReturnType<typeof customerApiCurrent>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<Awaited<ReturnType<typeof customerApiCurrent>>, TError, TData>
    >;
}): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getCustomerApiCurrentSuspenseQueryOptions(options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Customer address
 */
export const e413c8baa1c54f779d6e1ac03d7d8614 = (id: number, signal?: AbortSignal) => {
    return fetcherMagento<CustomerAddress>({
        url: `/api/rest/customer/address/${id}`,
        method: 'GET',
        signal,
    });
};

export const getE413c8baa1c54f779d6e1ac03d7d8614QueryKey = (id: number) => {
    return [`/api/rest/customer/address/${id}`] as const;
};

export const getE413c8baa1c54f779d6e1ac03d7d8614QueryOptions = <
    TData = Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
    TError = unknown,
>(
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getE413c8baa1c54f779d6e1ac03d7d8614QueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>> = ({
        signal,
    }) => e413c8baa1c54f779d6e1ac03d7d8614(id, signal);

    return {queryKey, queryFn, enabled: !!id, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type E413c8baa1c54f779d6e1ac03d7d8614QueryResult = NonNullable<
    Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>
>;
export type E413c8baa1c54f779d6e1ac03d7d8614QueryError = unknown;

/**
 * @summary Customer address
 */
export const useE413c8baa1c54f779d6e1ac03d7d8614 = <
    TData = Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
    TError = unknown,
>(
    id: number,
    options?: {
        query?: Partial<
            UseQueryOptions<
                Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
                TError,
                TData
            >
        >;
    },
): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getE413c8baa1c54f779d6e1ac03d7d8614QueryOptions(id, options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getE413c8baa1c54f779d6e1ac03d7d8614SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
    TError = unknown,
>(
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
                TError,
                TData
            >
        >;
    },
) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getE413c8baa1c54f779d6e1ac03d7d8614QueryKey(id);

    const queryFn: QueryFunction<Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>> = ({
        signal,
    }) => e413c8baa1c54f779d6e1ac03d7d8614(id, signal);

    return {queryKey, queryFn, enabled: !!id, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type E413c8baa1c54f779d6e1ac03d7d8614SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>
>;
export type E413c8baa1c54f779d6e1ac03d7d8614SuspenseQueryError = unknown;

/**
 * @summary Customer address
 */
export const useE413c8baa1c54f779d6e1ac03d7d8614Suspense = <
    TData = Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
    TError = unknown,
>(
    id: number,
    options?: {
        query?: Partial<
            UseSuspenseQueryOptions<
                Awaited<ReturnType<typeof e413c8baa1c54f779d6e1ac03d7d8614>>,
                TError,
                TData
            >
        >;
    },
): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getE413c8baa1c54f779d6e1ac03d7d8614SuspenseQueryOptions(id, options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @deprecated
 * @summary Customer address
 */
export const gen5b0c080030cdbef081b77339aa5a3641 = (
    id: number,
    customerAddress: CustomerAddress,
) => {
    return fetcherMagento<void>({
        url: `/api/rest/customer/address/${id}`,
        method: 'PUT',
        headers: {'Content-Type': 'application/json'},
        data: customerAddress,
    });
};

export const getGen5b0c080030cdbef081b77339aa5a3641MutationOptions = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen5b0c080030cdbef081b77339aa5a3641>>,
        TError,
        {id: number; data: CustomerAddress},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof gen5b0c080030cdbef081b77339aa5a3641>>,
    TError,
    {id: number; data: CustomerAddress},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof gen5b0c080030cdbef081b77339aa5a3641>>,
        {id: number; data: CustomerAddress}
    > = props => {
        const {id, data} = props ?? {};

        return gen5b0c080030cdbef081b77339aa5a3641(id, data);
    };

    return {mutationFn, ...mutationOptions};
};

export type Gen5b0c080030cdbef081b77339aa5a3641MutationResult = NonNullable<
    Awaited<ReturnType<typeof gen5b0c080030cdbef081b77339aa5a3641>>
>;
export type Gen5b0c080030cdbef081b77339aa5a3641MutationBody = CustomerAddress;
export type Gen5b0c080030cdbef081b77339aa5a3641MutationError = unknown;

/**
 * @deprecated
 * @summary Customer address
 */
export const useGen5b0c080030cdbef081b77339aa5a3641 = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof gen5b0c080030cdbef081b77339aa5a3641>>,
        TError,
        {id: number; data: CustomerAddress},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof gen5b0c080030cdbef081b77339aa5a3641>>,
    TError,
    {id: number; data: CustomerAddress},
    TContext
> => {
    const mutationOptions = getGen5b0c080030cdbef081b77339aa5a3641MutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Customer address
 */
export const fd13d8316ee1258377acd60a2ca607f2 = (signal?: AbortSignal) => {
    return fetcherMagento<CustomerAddress>({
        url: `/api/rest/customer/address`,
        method: 'GET',
        signal,
    });
};

export const getFd13d8316ee1258377acd60a2ca607f2QueryKey = () => {
    return [`/api/rest/customer/address`] as const;
};

export const getFd13d8316ee1258377acd60a2ca607f2QueryOptions = <
    TData = Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getFd13d8316ee1258377acd60a2ca607f2QueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>> = ({
        signal,
    }) => fd13d8316ee1258377acd60a2ca607f2(signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Fd13d8316ee1258377acd60a2ca607f2QueryResult = NonNullable<
    Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>
>;
export type Fd13d8316ee1258377acd60a2ca607f2QueryError = unknown;

/**
 * @summary Customer address
 */
export const useFd13d8316ee1258377acd60a2ca607f2 = <
    TData = Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>, TError, TData>
    >;
}): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getFd13d8316ee1258377acd60a2ca607f2QueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getFd13d8316ee1258377acd60a2ca607f2SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
            TError,
            TData
        >
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getFd13d8316ee1258377acd60a2ca607f2QueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>> = ({
        signal,
    }) => fd13d8316ee1258377acd60a2ca607f2(signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type Fd13d8316ee1258377acd60a2ca607f2SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>
>;
export type Fd13d8316ee1258377acd60a2ca607f2SuspenseQueryError = unknown;

/**
 * @summary Customer address
 */
export const useFd13d8316ee1258377acd60a2ca607f2Suspense = <
    TData = Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
    TError = unknown,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof fd13d8316ee1258377acd60a2ca607f2>>,
            TError,
            TData
        >
    >;
}): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getFd13d8316ee1258377acd60a2ca607f2SuspenseQueryOptions(options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};

/**
 * @summary Customer address
 */
export const a67ab99a5d989bbc836bdafcad44e43d = (customerAddress: CustomerAddress) => {
    return fetcherMagento<void>({
        url: `/api/rest/customer/address`,
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        data: customerAddress,
    });
};

export const getA67ab99a5d989bbc836bdafcad44e43dMutationOptions = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof a67ab99a5d989bbc836bdafcad44e43d>>,
        TError,
        {data: CustomerAddress},
        TContext
    >;
}): UseMutationOptions<
    Awaited<ReturnType<typeof a67ab99a5d989bbc836bdafcad44e43d>>,
    TError,
    {data: CustomerAddress},
    TContext
> => {
    const {mutation: mutationOptions} = options ?? {};

    const mutationFn: MutationFunction<
        Awaited<ReturnType<typeof a67ab99a5d989bbc836bdafcad44e43d>>,
        {data: CustomerAddress}
    > = props => {
        const {data} = props ?? {};

        return a67ab99a5d989bbc836bdafcad44e43d(data);
    };

    return {mutationFn, ...mutationOptions};
};

export type A67ab99a5d989bbc836bdafcad44e43dMutationResult = NonNullable<
    Awaited<ReturnType<typeof a67ab99a5d989bbc836bdafcad44e43d>>
>;
export type A67ab99a5d989bbc836bdafcad44e43dMutationBody = CustomerAddress;
export type A67ab99a5d989bbc836bdafcad44e43dMutationError = unknown;

/**
 * @summary Customer address
 */
export const useA67ab99a5d989bbc836bdafcad44e43d = <
    TError = unknown,
    TContext = unknown,
>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<typeof a67ab99a5d989bbc836bdafcad44e43d>>,
        TError,
        {data: CustomerAddress},
        TContext
    >;
}): UseMutationResult<
    Awaited<ReturnType<typeof a67ab99a5d989bbc836bdafcad44e43d>>,
    TError,
    {data: CustomerAddress},
    TContext
> => {
    const mutationOptions = getA67ab99a5d989bbc836bdafcad44e43dMutationOptions(options);

    return useMutation(mutationOptions);
};
/**
 * @summary Get last prescription for an authorized user
 */
export const a605433a59281bc20230da23c0f4c2f6 = (signal?: AbortSignal) => {
    return fetcherMagento<A605433a59281bc20230da23c0f4c2f6200Item[]>({
        url: `/api/rest/customer/prescription/last`,
        method: 'GET',
        signal,
    });
};

export const getA605433a59281bc20230da23c0f4c2f6QueryKey = () => {
    return [`/api/rest/customer/prescription/last`] as const;
};

export const getA605433a59281bc20230da23c0f4c2f6QueryOptions = <
    TData = Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>, TError, TData>
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getA605433a59281bc20230da23c0f4c2f6QueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>> = ({
        signal,
    }) => a605433a59281bc20230da23c0f4c2f6(signal);

    return {queryKey, queryFn, ...queryOptions} as UseQueryOptions<
        Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type A605433a59281bc20230da23c0f4c2f6QueryResult = NonNullable<
    Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>
>;
export type A605433a59281bc20230da23c0f4c2f6QueryError = ErrorResponse;

/**
 * @summary Get last prescription for an authorized user
 */
export const useA605433a59281bc20230da23c0f4c2f6 = <
    TData = Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseQueryOptions<Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>, TError, TData>
    >;
}): UseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getA605433a59281bc20230da23c0f4c2f6QueryOptions(options);

    const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {queryKey: QueryKey};

    query.queryKey = queryOptions.queryKey;

    return query;
};

export const getA605433a59281bc20230da23c0f4c2f6SuspenseQueryOptions = <
    TData = Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
            TError,
            TData
        >
    >;
}) => {
    const {query: queryOptions} = options ?? {};

    const queryKey = queryOptions?.queryKey ?? getA605433a59281bc20230da23c0f4c2f6QueryKey();

    const queryFn: QueryFunction<Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>> = ({
        signal,
    }) => a605433a59281bc20230da23c0f4c2f6(signal);

    return {queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<
        Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
        TError,
        TData
    > & {queryKey: QueryKey};
};

export type A605433a59281bc20230da23c0f4c2f6SuspenseQueryResult = NonNullable<
    Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>
>;
export type A605433a59281bc20230da23c0f4c2f6SuspenseQueryError = ErrorResponse;

/**
 * @summary Get last prescription for an authorized user
 */
export const useA605433a59281bc20230da23c0f4c2f6Suspense = <
    TData = Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
    TError = ErrorResponse,
>(options?: {
    query?: Partial<
        UseSuspenseQueryOptions<
            Awaited<ReturnType<typeof a605433a59281bc20230da23c0f4c2f6>>,
            TError,
            TData
        >
    >;
}): UseSuspenseQueryResult<TData, TError> & {queryKey: QueryKey} => {
    const queryOptions = getA605433a59281bc20230da23c0f4c2f6SuspenseQueryOptions(options);

    const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
        queryKey: QueryKey;
    };

    query.queryKey = queryOptions.queryKey;

    return query;
};
